/**
 * Confirm.show({ title, message, confirmText, cancelText, variant }) → Promise<boolean>
 *
 * Imperative singleton — class component / 비-React 모듈에서 호출 가능.
 * provider mount 전에 호출되면 안전하게 false(파괴적 액션 차단) 반환 + warn.
 */

let confirmInstance = null;

/**
 * ConfirmDialogProvider mount/unmount 시 호출. inst=null 이면 unmount.
 */
export const registerConfirmInstance = (inst) => {
    confirmInstance = inst;
};

export const Confirm = {
    show: (options) => {
        if (!confirmInstance) {
            console.warn("[Confirm] instance not mounted, defaulting to false (safe)");
            return Promise.resolve(false);
        }
        return confirmInstance.open(options || {});
    },
};
